<template>
  <span class="new-live-settings">
    <template v-if="loading">
      <v-skeleton-loader
        type="image"
        height="30px"
        width="30%"
        style="margin-top: 4px"
      ></v-skeleton-loader>
      <v-skeleton-loader
        v-for="(height, index) in [70, 210, 190, 100, 140]"
        :key="index"
        type="image"
        :height="`${height}px`"
        width="100%"
        style="margin-top: 20px"
      ></v-skeleton-loader>
    </template>

    <template v-else>
      <h2 class="page-title">{{ $t('message.routesTitles.Settings') }}</h2>

      <!-- always -->
      <LiveName v-bind="$attrs" :live-title="liveTitle" />
      <template v-if="notCreated">
        <v-divider />
        <LiveStream v-bind="$attrs" />
      </template>

      <!-- <template>
      <LiveKeys v-bind="$attrs" />
    </template> -->

      <template v-if="notCreated">
        <v-divider />
        <LiveCover
          :live-thumbnail="liveThumbnail"
          :live-player="livePlayer"
          v-bind="$attrs"
        />
      </template>

      <template
        v-if="
          liveStatus === 'offline' &&
          scheduled_at !== null &&
          isAfterScheduled == false
        "
      >
        <v-divider />
        <LiveSchedule :scheduled_at="scheduled_at" v-bind="$attrs" />
      </template>

      <template>
        <v-divider />
        <LiveRestream v-bind="$attrs" />
      </template>

      <template v-if="folderId !== null">
        <v-divider />
        <LiveFolder :folder-id="folderId" v-bind="$attrs" />
      </template>

      <template v-if="additionalQualities !== null">
        <v-divider />
        <LiveQualities
          :additional-qualities="additionalQualities"
          v-bind="$attrs"
        />
      </template>

      <template>
        <v-divider />
        <LiveDVR class="d-block mb-6" :propsData="{ activeDvr: isDvrActive }" />
      </template>
    </template>
  </span>
</template>

<script>
// external imports

// internal imports
import liveService from '@/services/liveServiceV2'

// API

// Components
import LiveName from './LiveName.vue'
import LiveStream from './LiveStream.vue'
//import LiveKeys from './LiveKeys.vue'
import LiveCover from './LiveCover.vue'
import LiveSchedule from './LiveSchedule.vue'
import LiveRestream from './LiveRestream.vue'
import LiveFolder from './LiveFolder.vue'
import LiveQualities from './LiveQualities.vue'
import LiveDVR from './LiveDVR.vue'

export default {
  name: 'NewLiveV2Settings',
  components: {
    LiveName,
    LiveStream,
    //LiveKeys,
    LiveCover,
    LiveSchedule,
    LiveRestream,
    LiveFolder,
    LiveQualities,
    LiveDVR,
  },
  data: () => ({
    created_at: null,
    isAfterScheduled: false,
    scheduled_at: null,
    liveStatus: null,
    defaultThumbnail: null,
    additionalQualities: null,
    livePlayer: null,
    folderId: null,
    loading: true,
    liveTitle: null,
    isDvrActive: false,
    showRestream: false,
  }),
  inject: ['isOnline', 'notCreated'],
  computed: {
    // ...
  },

  async mounted() {
    await this.getLiveInfo()
    this.scheduledCheck()
    this.$root.$on('liveStarted', () => {
      this.isAfterScheduled = true
      this.showRestream = true
    })
    this.$root.$on('handleRestream', (val) => {
      this.showRestream = val
    })
  },

  methods: {
    async getLiveInfo() {
      const response = await liveService.getLive(this.$route.params.id)

      this.created_at = response.data.created_at
      this.scheduled_at = response.data.scheduled_at
      this.liveStatus = response.data.status
      this.additionalQualities = response.data.bitrate
      this.folderId = response.data.folder_id
      this.isDvrActive = response.data.active_dvr
      this.liveThumbnail = response.data.config.thumbnail || ''
      this.liveTitle = response.data.title
      this.livePlayer = response.data.live_player
      this.handleShowReastream()

      this.$emit('live-scheduled-at-updated', this.scheduled_at)

      this.loading = false
    },
    handleShowReastream() {
      if (!this.scheduled_at) {
        this.showRestream = true
      }
    },

    scheduledCheck() {
      let currentTime = new Date()
      let scheduledTime = new Date(this.scheduled_at)
      if (currentTime > scheduledTime) {
        this.isAfterScheduled = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.new-live-settings {
  font-size: 1rem;
  color: var(--v-neutral-lighten1);

  &::v-deep {
    @import '@/assets/scss/src/new-live';
  }
}

// @media screen and (min-width: 1621px) {
//   .new-live-settings {
//     width: 50%;
//   }
// }

.bg-dark {
  .new-live-settings {
    background-color: var(--v-neutral-darken2);
    color: white;
  }

  .page-title {
    color: var(--v-brand-lighten2);
  }
}
</style>
